console.log = () => {};
import { AppRegistry } from 'react-native';
import 'setimmediate';

import AppProtected from './js/AppProtected.web.js';
import App from './js/App.web.js';

import { USE_OKTA, env } from './js/constants/env';

// Direct CSS imports - style-loader will handle injection
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

// Font and Google Maps scripts remain the same
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css?family=Montserrat';
document.head.appendChild(link);

// Resources
require('./resources/apple-touch-icon.png');
require('./resources/favicon-32x32.png');
require('./resources/favicon-16x16.png');
require('./resources/safari-pinned-tab.svg');

// App registration
AppRegistry.registerComponent('Outpatient', () => (env(USE_OKTA) ? AppProtected : App));

AppRegistry.runApplication('Outpatient', {
  initialProps: {},
  rootTag: document.getElementById('react-app'),
});

if (module.hot) {
  module.hot.accept();
}
